import { Box, Button, Stack, Typography } from '@mui/material';
import { History as HistoryIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { useHarnessStore } from '@/store/useHarnessStore';
import { BatchControls } from './components/BatchControls';
import { MeasurementRunner } from './components/MeasurementRunner';
import { MeasurementList } from './components/MeasurementList';
import { LiveCommunicationLog } from './components/LiveCommunicationLog';
import { MeasurementPlot } from './components/MeasurementPlot';
import { CurveParametersPanel } from './components/CurveParametersPanel';
import { ExcitationProfilePanel } from './components/ExcitationProfilePanel';
import { MeasurementAnnotationPanel } from './components/MeasurementAnnotationPanel';
import { ExportButton } from './components/ExportButton';

export function HarnessPage() {
  const activeBatch = useHarnessStore((s) => s.activeBatch);
  const selectedMeasurementIds = useHarnessStore((s) => s.selectedMeasurementIds);
  const measurements = useHarnessStore((s) => s.measurements);
  const updateMeasurementNote = useHarnessStore((s) => s.updateMeasurementNote);

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', py: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="h5">Device Testing Harness</Typography>
        <Stack direction="row" spacing={1}>
          {activeBatch && <ExportButton batchId={activeBatch.id} />}
          <Button
            component={RouterLink}
            to="/harness/batches"
            startIcon={<HistoryIcon />}
            size="small"
          >
            Browse past Batches
          </Button>
        </Stack>
      </Box>
      <BatchControls />
      <MeasurementRunner />
      <MeasurementList />
      <MeasurementPlot />
      <CurveParametersPanel />
      <ExcitationProfilePanel />
      <MeasurementAnnotationPanel
        batchId={activeBatch?.id ?? null}
        selectedIds={selectedMeasurementIds}
        measurements={measurements}
        onMeasurementNoteSaved={updateMeasurementNote}
      />
      <LiveCommunicationLog />
    </Box>
  );
}
